import { render, staticRenderFns } from "./accessGuideDoc.vue?vue&type=template&id=5fdcfcaa&scoped=true&"
import script from "./accessGuideDoc.vue?vue&type=script&lang=js&"
export * from "./accessGuideDoc.vue?vue&type=script&lang=js&"
import style0 from "./accessGuideDoc.vue?vue&type=style&index=0&id=5fdcfcaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdcfcaa",
  null
  
)

export default component.exports